<template>
  <MenuPage :_categories="categories" />
</template>

<script>
import MenuPage from '@/components/pages/common/MenuPage'
import { FunctionCd, S3Root, ManualFileName } from '@/enum'

export default {
  name: 'OQCMenuPage',

  components: {
    MenuPage,
  },

  data() {
    return {
      categories: [],
    }
  },

  mounted() {
    if (!this.$store.getters.canOQCOnly) {
      this.$router.push({ name: 'TopMenu' }).catch(() => {})
    }

    this.categories = [
      {
        name: this.$t('ELE0064'),
        size: 2,
        icon: 'mdi-text-box-edit',
        color: '#FCF4A1',
        iconColor: '#948D2B',
        items: [
          { functionCd: FunctionCd.IMPORT_INSP_INDEX, route: 'T01' },
          { functionCd: FunctionCd.SEARCH_INSP_INDEX, route: 'T02' },
          { functionCd: FunctionCd.EDIT_INSP_INDEX, route: 'T03' },
        ],
      },
      {
        name: this.$t('ELE0491'),
        size: 2,
        icon: 'mdi-stamper',
        color: '#F8D8AF',
        iconColor: '#C46200',
        items: [
          { functionCd: FunctionCd.SEARCH_MMMM_HISTORY, route: 'T29' },
          { functionCd: FunctionCd.REQUEST_MMMM, route: 'T30' },
        ],
      },
      {
        name: this.$t('ELE0065'),
        size: 2,
        icon: 'mdi-stamper',
        color: '#F8D8AF',
        iconColor: '#C46200',
        items: [
          { functionCd: FunctionCd.SEARCH_SA_HISTORY, route: 'T06' },
          { functionCd: FunctionCd.REQUEST_SA, route: 'T07' },
        ],
      },
      {
        name: this.$t('ELE0066'),
        size: 2,
        icon: 'mdi-file-edit',
        color: '#C9E0A7',
        iconColor: '#3A8A3E',
        items: [
          { functionCd: FunctionCd.SEARCH_INSP_RESULT, route: 'T09' },
          { functionCd: FunctionCd.INPUT_APP_INSP, route: 'T10' },
          { functionCd: FunctionCd.INPUT_DIM_INSP, route: 'T11' },
          { functionCd: FunctionCd.IMP_INSP_DATA_CSV, route: 'T12' },
          { functionCd: FunctionCd.EXPORT_INSP_DATA_CSV, route: 'T13' },
        ],
      },
      {
        name: this.$t('ELE0067'),
        size: 2,
        icon: 'mdi-hand-okay',
        color: '#DDBFE6',
        iconColor: '#9333AE',
        items: [{ functionCd: FunctionCd.APPD_INSP_DATA, route: 'T19' }],
      },
      {
        name: this.$t('ELE0068'),
        size: 2,
        icon: 'mdi-chart-bar',
        color: '#BEE6D6',
        iconColor: '#92B0A4',
        items: [
          { functionCd: FunctionCd.DEFECT_PARETO_CHART, route: 'R01' },
          { functionCd: FunctionCd.MEAS_VALUE_PLOT_CHART, route: 'R02' },
        ],
      },
      {
        name: this.$t('ELE0337'),
        size: 2,
        icon: 'mdi-download',
        color: '#C9E0A7',
        iconColor: '#3A8A3E',
        isManualDownLoad: true,
        items: [{ name: this.$t('ELE0072'), filePath: S3Root.MANUAL + '/' + ManualFileName.OQC }],
      },
    ]
  },
}
</script>
